export default __webpack_public_path__ + "i18n/translation-de.f8b84d26.json";